<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations, DxHeaderFilter
} from 'devextreme-vue/data-grid';
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import DxButton from "devextreme-vue/button";
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from "file-saver-es";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "DocCob",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, PageHeader, Loader, Multiselect,
    DxItem, DxButton, DxToolbar,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxPager,  DxFilterRow, DxRemoteOperations, DxHeaderFilter},


  setup() {
  },
  data() {
    return {
      title: "DocCob",
      items: [
        {
          text: "Financeiros",
          href: "/financeiros/doccobs",
        },
        {
          text: "DocCob",
          active: true,
        },
      ],
      updating: true,
      docCobData: {
        id: 0,
        status: 'AB'
      },
      idData: 0,
      docCobCobrancas: null,
      docCobCtes: null,
      docCobNotas: null,
      submitted: false,
      errosValid: null,
      totalNf: 0,
      totalCte: 0,
      // totalCargaCte: 0,
      totalPerc: 0,
      totaldif: 0,
      maxSelectedRows: 50,
      maxRowLimit: 50,
      allowSelectAll: true,

      showModalFinan: false,
      financeiroData: {},
      dtListPesqCondPgto: null,
      dtlistPesqCategoria: null,
      dtlistPesqNatureza: null,
      dtListPesqConta: null,
      dtListPesqFormaPgto: null,
      tipoFinTransp: 'P',

      docCobEditable: false,
      showModalCobr: false,
      docCobCobrEdit: {},
    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  methods: {

    abrirCte(idData){
      console.log('abrirCte')
      const routeData = this.$router.resolve(`/movcte/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    cotarFrete(){
      console.log('cotarFrete_cte ID::')
      const selectedRows = this.dataGrid.getSelectedRowsData()

      const idsAtualizar = selectedRows.map(row => row.ctexiste)
      const doccobId = selectedRows.map(row => row.doccob_id)
      this.idData = doccobId

      // console.log('idsAtualizar')
      // console.log(idsAtualizar)
      // console.log(idsAtualizar.length)

      const arrayNull = idsAtualizar.every(id => id === null)
      if(!arrayNull){
        this.updating = true

        api.get(`${getBaseUrl()}api/cotarfretectesint`, {
          params: {
            'ids': idsAtualizar
          }
        }).then((res) => {
          console.log('res cotarFrete')
          console.log(res.data)

          const resEcono = res.data

          if (resEcono['SDT_WSRetorno'] && resEcono['SDT_WSRetorno']['Messages']) {
            console.log('existe erro')
            let erros = resEcono['SDT_WSRetorno']['Messages']
            console.log(erros)
            console.log(typeof  erros)
            let listaErros = []
            erros.forEach((erro) => {
              listaErros.push({
                'titulo': erro['Description'],
                'mensagem': erro['Type']
              })
            })
            this.errosValid = listaErros
            this.showModalCotarFrete = false
          }

          else if (resEcono[1]) {
            console.log('existe resultado')

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.carregarDados()
          }
        })

      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Não há CTe associado!",
          showConfirmButton: false,
          timer: 3000
        });
      }
    },

    confirmaStatus(status) {
      console.log('ConfirmaStaus')

      // console.log(status)
      this.docCobData.status = status
      console.log("status" , this.docCobData.status)

      api.post(`${getBaseUrl()}api/salvarstatus`, {
        iddata : this.idData,
        doccobdata : this.docCobData,
      }, {
        responseType: 'blob'
      }).then((res) => {
        console.log(res)

        Swal.fire({
          position: "top-end",  
          icon: "success",
          title: "Status atualizado!",
          showConfirmButton: false,
          timer: 3000
        });

      }).then(() => {
        this.carregarDados()
      });
    },

    carregarDados(){
      this.updating = true

      api.get(`${getBaseUrl()}api/doccob`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios doccob')
        console.log(res.data)
        this.docCobData = res.data[0]
        this.docCobCobrancas = res.data[1]
        this.docCobCtes = res.data[2]
        this.docCobNotas = res.data[3]
        this.docCobEditable = res.data[4]


        this.idData = this.docCobData.id
        this.title = `DocCob (${this.docCobData.id}) ${this.docCobData.cxpostdest} - ${this.docCobData.razaotransp}`
        if (['PG', 'NG'].includes(this.docCobData.status)) 
          this.docCobEditable = false

        const data = res.data[2];
        data.forEach((item, index) => {
          //diferença da cotação - Conciliação
          if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valoratucota))) {
            const movcte_difvalcota = parseFloat(item.movcte_valoratucota) - parseFloat(item.movcte_valor);
            data[index].movcte_difvalcota = parseFloat(movcte_difvalcota);
          } else {
            data[index].movcte_difvalcota = null;
          }
          //diferença da cotação - Menor frete
          if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valormincota))) {
            const movcte_difvalmin = parseFloat(item.movcte_valor) - parseFloat(item.movcte_valormincota);
            data[index].movcte_difvalmin = parseFloat(movcte_difvalmin);
          } else {
            data[index].movcte_difvalmin = null;
          }
          //diferença da cotação - Menor Prazo
          if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valorprazmin))) {
            const movcte_difprazmin = parseFloat(item.movcte_valor) - parseFloat(item.movcte_valorprazmin);
            data[index].movcte_difprazmin = parseFloat(movcte_difprazmin);
          } else {
            data[index].movcte_difprazmin = null;
          }
          //frete percentual da conciliação
          if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valormincota))) {
            const movcte_percentualcota = (parseFloat(item.movcte_valor) / parseFloat(item.movcte_valorcarga))*100;
            data[index].movcte_percentualcota = parseFloat(movcte_percentualcota);
          } else {
            data[index].movcte_percentualcota = null;
          }
        });

        const totaldata = this.docCobCtes;
        totaldata.forEach((item) => {


          this.totalNf += parseFloat(item.nfvalor) || 0;
          this.totalCte += parseFloat(item.valor)  || 0;
          // this.totalCargaCte += parseFloat(item.movcte_valorcarga)  || 0;
          this.totaldif += parseFloat(item.movcte_difvalcota) || 0;

        });

        this.totalPerc = (this.totalCte / this.totalNf) * 100 || 0;
        this.updating = false
      });
    },

    nomeStatus(status) {
      switch (status) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'AT':
          return 'Autorizado(AT)'
        case 'PD':
          return 'Pendente(PD)'
        case 'PG':
          return 'Pago(PG)'
        case 'NG':
          return 'Negado(NG)'
      }
      return status
    },

    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ") DocCob"
      const totalCount = e.component.totalCount();
      if (totalCount > this.maxRowLimit) {
        this.allowSelectAll = false;
      }
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(248,178,58,0.82)'
              break
            case 'AT':
              corStatus = 'rgba(101,166,249,0.82)'
              break
            case 'PD':
              corStatus = 'rgba(175,117,12,0.82)'
              break
            case 'PG':
              corStatus = 'rgba(46,184,134,0.96)'
              break
            case 'NG':
              corStatus = 'rgba(223,121,106,0.98)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }

        if (e.column.dataField === "ctexiste") {
          const existeCte = e.data.ctexiste
          let corCte = null
          if(existeCte !== null) {
            corCte = 'rgb(125,189,110)'
          } else {
            corCte = 'rgba(232,203,99,0.99)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corCte}`;

        } else if (e.column.dataField === "movcte_difvalcota") {
          const valDif = e.data.movcte_difvalcota
          const valFretConc = e.data.movcte_valoratucota
          let corDif = null
          if (valFretConc <= 0 || valDif < 0 ) {
            corDif = 'rgb(248,101,101)'
          } else if (valDif === 0){
            corDif = 'rgba(125,189,110)'
          } else {
            corDif = 'rgb(5,126,236)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDif}`;
        }
      }
    },

    onRowDblClick(e) {
      console.log('onRowDblClick')
      let idData = e.data.ctexiste
      if(idData !== null){
        const routeData = this.$router.resolve(`/movcte/editar/${idData}`)
        window.open(routeData.href, '_blank')
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Não há CTe associado!",
          showConfirmButton: false,
          timer: 3000
        });
      }
    },

    // onSelectionChanged(e) {
    //   consele.log(this.selectedRowKeys)
    //   const selectedRowKeys = e.selectedRowKeys;
    //   // if (selectedRowKeys.length > this.maxSelectedRows) {
    //   //   // Desmarcar a última linha selecionada
    //   //   const deselectKey = selectedRowKeys[this.maxSelectedRows + 1];
    //   //   e.component.deselectRows([deselectKey]);
    //   //   // Opcional: exibir uma mensagem ao usuário
    //   //   alert(`Você só pode selecionar até ${this.maxSelectedRows} linhas.`);
    //   // }
    // },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    imprimir() {
      console.log('imprimir')
      this.updating = true

      api.post(`${getBaseUrl()}api/reldoccob`, {
        iddata : this.idData,
        doccobdata : this.docCobData,
        doccobcobrancas : this.docCobCobrancas,
        doccobctes : this.docCobCtes,
      }, {
        responseType: 'blob'
        }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_doccobRelatorio_doccob' + this.idData + '.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      }).catch(function (error){
        console.log('erro na emissão do relatório do doccob:')
        console.log(error)

        Swal.fire({
          position: "top-end",
          icon: 'error',
          text: 'Erro na emissão do relatório',
          timer: 3000,
          showCancelButton: false,
          showConfirmButton: false
        }).then(() => {
          this.atualizaPagina()
        })
      })
    },

    modalFinanceiro() {
      console.log('modalFinanceiro')
      const dtemissao =  moment(this.docCobCobrancas[0].dtemissao).format('YYYY-MM-DD')
      const dtvencto = moment(this.docCobCobrancas[0].dtvencto).format('YYYY-MM-DD')

      const naturezadescr = this.docCobCobrancas[0]?.naturezadescr ?? null;
      this.tipoFinTransp = naturezadescr === 'Prestação de Serviço de Transporte' ? 'R' : 'P';

      this.dtlistPesqNatureza = [
        {
          id: this.docCobCobrancas[0].natureza,
          descricao: this.docCobCobrancas[0].naturezadescr
        }
      ]

      this.financeiroData = {
        status: 'A',
        stsbaixa: 'AB',
        tipo: this.tipoFinTransp,
        qtdrecorrencia: 0,
        atributorecorrencia: 'FINA',
        intervParcelasRecorrencia: 30,
        valor: this.docCobCobrancas[0].valor,
        emissao: dtemissao,
        vencimento: dtvencto,
        empresa: this.tipoFinTransp === 'R' ? this.docCobCobrancas[0].cnpjemis : this.docCobCobrancas[0].cnpjremet,
        pessoa: this.docCobCobrancas[0].cnpjemis,
        numero: this.docCobCobrancas[0].numdoc,
        codigo: this.docCobCobrancas[0].numdoc,
        categoria: null,
        natureza: this.docCobCobrancas[0].natureza ?? null,
        formapgto: null,
        condpgto: false,
        intervParcCondPgto: Math.abs(moment(dtemissao).diff(moment(dtvencto), 'days')),
        ocorrencia: 'COND',
        qtdparc: 1 ,
        consutil: false,
        banco: null,
        banco_id: null,
        tabela: 'doccob',
        origem_id: this.docCobCobrancas[0].doccob_id,
      }
      this.showModalFinan = true
    },

    gerarFinanceiro() {
      console.log('gerarFinanceiro')

      api.post(`${getBaseUrl()}api/criarfinandoc`, {
        iddata: this.idData,
        financeiro: this.financeiroData
      }).then((res) => {
        console.log('then axios get criarfinandoc:')
        console.log(JSON.stringify(res.data))

        if (res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          })

          this.showModalFinan = false;
          this.carregarDados()
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          })
        }
      })
    },

    redirectFinanceiro() {
      console.log('redirectFinanceiro')

      if(this.docCobCobrancas[0].financ_id) {
        const routeData = this.$router.resolve(`/cpagar/editar/` + this.docCobCobrancas[0].financ_id)
        window.open(routeData.href, '_blank')
      }

    },

    pesqCondPgto(evt) {
      console.log('pesqCondPgto')
      console.log(evt)
      let query = evt

      console.log(query.length)
      if (query.length > 1) {
        this.loadingCondPgto = true
        this.financeiroData.condpgto = ''
        api.get(`${getBaseUrl()}api/cpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCondPgto = res.data
        })
      }
    },

    escolheuCondPgto() {
      console.log('escolheuCondPgto')
      this.loadingCondPgto = true
      // console.log(this.financeiroData.condpgto)
      api.get(`${getBaseUrl()}api/cpgtocod`, {
        params: { coddata: this.financeiroData.condpgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.condPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingCondPgto = false
      })
    },

    pesqCategoria(evt) {
      console.log('pesqCategoria')
      console.log(evt)
      let query = evt
      // console.log(query.length)
      if (query.length > 1) {
        this.loadingCategoria = true
        this.financeiroData.categoria = ''
        api.get(`${getBaseUrl()}api/pesqcateg`, {
          params: { q: query, t: this.financeiroData.tipo, f: this.financeiroData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqCategoria = res.data
          this.dtlistPesqCategoria.sort((a,b) => a.id - b.id);
        })
      }
    },

    escolheuCategoria(){
      console.log('escolheuCategoria')

      if(Array.isArray(this.dtlistPesqCategoria) && this.dtlistPesqCategoria.length > 0) {
        this.categoriaData = this.dtlistPesqCategoria.find((categoria) => {
          if (categoria.id === this.financeiroData.categoria){
            console.log('categoria selected:')
            console.log(categoria)

            return categoria
          }
        })

        this.loadingCategoria = false
        this.financeiroData.categoria = this.categoriaData.id
      }
    },

    pesqNatureza(evt) {
      console.log('pesqNatureza')
      console.log(evt)
      let query = evt
      // console.log(query.length)
      if (query.length > 1) {
        this.loadingNatureza = true
        this.financeiroData.natureza = ''
        api.get(`${getBaseUrl()}api/naturpesq`, {
          params: { q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqNatureza = res.data
          this.dtlistPesqNatureza.sort((a,b) => a.id - b.id);
        })
      }
    },

    escolheuNatureza(){
      console.log('escolheuNatureza')

      if(Array.isArray(this.dtlistPesqNatureza) && this.dtlistPesqNatureza.length > 0) {
        this.naturezaData = this.dtlistPesqNatureza.find((natureza) => {
          if (natureza.id === this.financeiroData.natureza){
            console.log('natureza selected:')
            console.log(natureza)

            return natureza
          }
        })

        this.loadingNatureza = false
        this.financeiroData.natureza = this.naturezaData.id
      }
    },

    pesqConta(evt){
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/ccontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqConta = res.data
          this.dtListPesqConta.sort((a,b) => a.codigo - b.codigo);
        });
      }
    },

    escolheuConta() {
      console.log('selectedContaData', this.financeiroData.banco_id)
      this.loadingConta = true;
      console.log(this.financeiroData.banco_id);
      api.get(`${getBaseUrl()}api/cconta`, {
        params: { iddata: this.financeiroData.banco_id },
      }).then((res) => {
        console.log("then axios");
        // console.log(res.data);
        this.ContaData = res.data[0];

        this.loadingConta = false;
        this.financeiroData.banco_id = this.ContaData.id;
        this.financeiroData.banco = this.ContaData.banco;
      });
    },

    pesqFormaPgto(evt) {
      console.log("pesqFormaPgto");
      console.log(evt);
      let query = evt;
      if (query.length > 1) {
        this.loadingFormaPgto = true;
        this.financeiroData.formapgto = "";
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: { q: query },
        })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtListPesqFormaPgto = res.data;
              this.dtListPesqFormaPgto.sort((a,b) => a.id - b.id);
            });
      }
    },

    escolheuFormaPgto() {
      console.log("escolheuFormaPgto");
      this.loadingFormaPgto = true;

      api.get(`${getBaseUrl()}api/fpgtocod`, {
        params: { coddata: this.financeiroData.formapgto },
      })
          .then((res) => {
            console.log("then axios");
            console.log(res.data);
            this.formaPgtoData = res.data[0];

            this.loadingFormaPgto = false;
            this.financeiroData.formapgto = this.formaPgtoData.codigo
          });
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    saveDocCobCobr() {
      console.log('saveDocCobCobr')

      this.docCobCobrEdit.dtemissao = moment(this.docCobCobrEdit.dtemissao).format('YYYY-MM-DD')
      this.docCobCobrEdit.dtvencto = moment(this.docCobCobrEdit.dtvencto).format('YYYY-MM-DD')

      const cobrDataToSend = this.docCobCobrEdit

      api.post(`${getBaseUrl()}api/editardoccobcobr`, {
        cobrData: cobrDataToSend
      }).then((res) => {
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          text: res.data.message,
          showConfirmButton: false,
          timer: 1500
        })
      })
      .catch((error) => {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Erro ao salvar as informações!",
          text: error.response?.data?.message || "Erro desconhecido",
          showConfirmButton: false,
          timer: 3000
        })
      })
      

      this.showModalCobr = false
      this.docCobCobrancas = null
      this.docCobCobrEdit = {}
      this.carregarDados()
    },

    openCobrModal(cobrData) {
      console.log('openCobrModal')
      console.log(cobrData)
      
      this.docCobCobrEdit = {
        ...cobrData,
        dtemissao: this.formatDateToInput(cobrData.dtemissao),
        dtvencto: this.formatDateToInput(cobrData.dtvencto)
      }
      this.showModalCobr = true
    },

    formatDateToInput(dateString) {
      dateString = dateString.trim()
      
      if (/^\d{4}-\d{2}-\d{2}/.test(dateString)) 
        return dateString.substring(0, 10)
      
      if (/^\d{2}\/\d{2}\/\d{4}/.test(dateString)) {
        const [day, month, year] = dateString.substring(0, 10).split('/')
        return `${year}-${month}-${day}`
      }
      
      const date = new Date(dateString)
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
      
      return ''
    },

    formatDateToAPI(dateString) {
      dateString = dateString.trim().substring(0, 10)
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) 
        return dateString
      return ''
    },

    atualizaPagina() {
      window.location.reload();
    },

    unlinkCtes(){
      console.log('unlinkCtes')
      const ctes = this.dataGrid.getSelectedRowsData()
      
      if(ctes?.length > 0) {
        Swal.fire({
          title: 'Deseja desvincular os CTEs selecionados?',
          text: `
            Serão desvinculados ${ctes.length} CTEs do DocCob, 
            caso não reste mais CTEs o doccob sera finalizado.
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            const idsCtes = ctes.map(cte => cte.ctexiste)
            console.log('idsCtes para desvincular:')
            console.log(idsCtes)
            
            api.post(`${getBaseUrl()}api/desvinculardoccobctes`, {
              doccob_id: this.idData,
              cteids: idsCtes
            }).then((res) => {
              console.log('then axios desvinculardoccobctes:')
              console.log(res.data)
              
              if (res.data.success) {
                Swal.fire({
                  position: 'top-end',
                  icon: 'success',
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 5000,
                })
              } else {
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: res.data.message,
                  text: res.data.errors.map(error => `${error.numcte}: ${error.message}`).join('\n'),
                  showConfirmButton: true,
                })
              }
            }).catch((res) => {
              console.log('catch axios desvinculardoccobctes:')
              console.log(res)

              Swal.fire({
                position: 'center',
                icon: 'error',
                title: res.data.message,
                text: res.data.errors.map(error => `${error.numcte}: ${error.message}`).join('\n'),
                showConfirmButton: true,
              })
            })
            .then(() => {
              this.carregarDados()
            })
          }
        })
      } else {
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: `Nenhum CTE foi selecionado!`,
          text: `É necessário selecionar ao menos um CT-e para desvincular.`,
          showConfirmButton: false,
          timer: 2500,
        })
      }
    },
  },

  created() {

    this.userLogged = JSON.parse(localStorage.getItem('user'))

  },

  mounted() {
    console.log('mounted_docCob_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    this.carregarDados()
  },

  watch: {
    'docCobData.valorbrt': {
      handler() {
        this.calculaTotal()
      }
    },
    'docCobData.desconto': {
      handler() {
        this.calculaTotal()
      }
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="`${nomeStatus(docCobData.status)}`"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating">

      <div class="d-flex align-items-start">
        <b-button variant="outline-success" class="mx-2" :disabled="true" >
          <i class="bx bx-save font-size-16 align-middle me-2"></i>
          Salvar
        </b-button>

        <b-button variant="outline-danger" class="mx-2" :disabled="true">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>

        <b-button
            v-if="!docCobCobrancas[0]?.financ_id" variant="outline-primary" class="mx-2" @click="modalFinanceiro">
          <i class="bx bx-money font-size-16 align-middle me-2"></i>
          Gerar Financeiro
        </b-button>

        <b-dropdown
            variant="outline-primary"
            toggle-class="btn btn-outline-primary mx-2"
            menu-class="dropdown-menu-end">
          <template #button-content>
            <i class="bx bx-pencil font-size-16 align-middle me-2"></i>
            Editar Status
          </template>
          <b-dropdown-item href="#" @click="confirmaStatus('EL')"> Elaboração </b-dropdown-item>
          <b-dropdown-item href="#" @click="confirmaStatus('AT')"> Autorizado </b-dropdown-item>
          <b-dropdown-item href="#" @click="confirmaStatus('PD')"> Pendente </b-dropdown-item>
          <b-dropdown-item href="#" @click="confirmaStatus('PG')"> Pago </b-dropdown-item>
          <b-dropdown-item href="#" @click="confirmaStatus('NG')"> Negado </b-dropdown-item>
        </b-dropdown>

        <div class="ms-auto">
          <b-button variant="outline-info" class="mx-2" @click="imprimir" v-if="docCobData && docCobData.id > 0">
            <i class="bx bx-printer font-size-16 align-middle me-2"></i>
            Imprimir
          </b-button>
        </div>
      </div>


      <form class="needs-validation">
        <div class="card">
          <div class="card-body">
            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0"> Informações Principais </h6>
            </b-card-header>

            <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
              <b-card-body>
                <div class="row mb-2">
                  <div class="row mb-2 col-12">
                    <div class="col-4">
                      <label for="cxpostremt">Remetente</label>
                      <div class="position-relative">
                        <input id="cxpostremt"
                               type="text"
                               v-model="docCobData.cxpostremt"
                               class="form-control"
                               placeholder="Remetente"
                               :disabled="true"/>
                      </div>
                    </div>
                    <div class="col-2">
                      <label for="cnpjremet">CNPJ Remet</label>
                      <div class="position-relative">
                        <input id="cnpjremet"
                               type="text"
                               v-model="docCobData.cnpjtransp"
                               class="form-control"
                               placeholder="CNPJ"
                               :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-2">
                      <label for="idinterc">ID. Intercâmbio</label>
                      <div class="position-relative">
                        <input id="idinterc"
                               type="text"
                               v-model="docCobData.idinterc"
                               class="form-control"
                               placeholder="ID. Intercâmbio"
                               :disabled="true"/>
                      </div>
                    </div>
                    <div class="col-2">
                      <label for="iddoc">ID. Documento</label>
                      <div class="position-relative">
                        <input id="iddoc"
                               type="text"
                               v-model="docCobData.iddoc"
                               class="form-control"
                               placeholder="ID. Documento"
                               :disabled="true"/>
                      </div>
                    </div>
                    <div class="col-2">
                      <label for="valor">Valor</label>
                      <div class="position-relative">
                        <input id="valor"
                               type="number"
                               v-model="docCobData.valor"
                               class="form-control text-end"
                               placeholder="CNPJ"
                               :disabled="true"/>
                      </div>
                    </div>
                  </div>

                  <div class="row col-12">
                    <div class="col-4">
                      <label for="cxpostdest">Destinatário</label>
                      <div class="position-relative">
                        <input id="cxpostdest"
                               type="text"
                               v-model="docCobData.cxpostdest"
                               class="form-control"
                               placeholder="Destinatário"
                               :disabled="true"/>
                      </div>
                    </div>
                    <div class="col-2">
                      <label for="cnpjdest">CNPJ Dest.</label>
                      <div class="position-relative">
                        <input id="cnpjdest"
                               type="text"
                               v-model="docCobCobrancas[0].cnpjtomador "
                               class="form-control"
                               placeholder="CNPJ"
                               :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-4">
                      <label for="razaotransp">Transportador</label>
                      <div class="position-relative">
                        <input id="razaotransp"
                               type="text"
                               v-model="docCobData.razaotransp"
                               class="form-control"
                               placeholder="Transportador"
                               :disabled="true"/>
                      </div>
                    </div>
                    <div class="col-2">
                      <label for="cnpjtransp">CNPJ Transp.</label>
                      <div class="position-relative">
                        <input id="cnpjtransp"
                               type="text"
                               v-model="docCobData.cnpjtransp"
                               class="form-control"
                               placeholder="CNPJ"
                               :disabled="true"/>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0"> Informações sobre as Cobranças </h6>
            </b-card-header>

            <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
              <b-card-body>
                <div class="row mb-2">
                  <table class="table align-middle table-nowrap">
                    <thead class="table-light">
                    <tr>
                      <th class="align-middle">ID</th>
                      <th>Número</th>
                      <th>Emissor</th>
                      <th>CNPJ Emissor</th>
                      <th>Tomador</th>
                      <th>CNPJ Tomador</th>
                      <th>Emissão</th>
                      <th>Vencimento</th>
                      <th>Tipo</th>
                      <th>Banco</th>
                      <th class="text-end">Valor</th>
                      <th class="text-center" v-if="docCobEditable">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in docCobCobrancas" :key="data.id">
                      <td>
                        <a href="javascript: void(0);" class="text-body fw-bold" >
                          #{{ data.id }}
                        </a>
                      </td>
                      <td>{{ data.numdoc }}</td>
                      <td>{{ data.nomeemis }}</td>
                      <td>{{ data.cnpjemis }}</td>
                      <td>{{ data.nometomador}}</td>
                      <td>{{ data.cnpjtomador}}</td>
                      <td>{{ formatDate(data.dtemissao) }}</td>
                      <td>{{ formatDate(data.dtvencto) }}</td>
                      <td>{{ data.tipocob }}</td>
                      <td>{{ data.nomebanco }}</td>
                      <td class="text-end">{{ formatDecimal(data.valor) }} </td>
                      <td class="text-center">
                        <b-button 
                          variant="outline-info" 
                          size="sm"
                          @click="openCobrModal(data)"
                          v-if="docCobEditable"
                        >
                          <i class="bx bx-pencil font-size-16 align-middle"></i>
                          Editar
                        </b-button>
                    </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </b-card-body>
            </b-collapse>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <b-card-header header-tag="header" role="tab" class="mb-4">

              <div class="d-flex align-items-center">
                <h6 class="m-0"> Conhecimentos de Transporte </h6>

                <div class="d-flex align-items-center justify-content-between col-6" style="margin-left: 60ch">
                  <div class="d-flex align-items-center">
                    <h6 class="m-0 me-2" > Total NF: </h6>
                    <p class="m-0 me-4">{{ formatDecimal(this.totalNf) }}</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <h6 class="m-0 me-2"> Total CTe:</h6>
                    <p class="m-0 me-4">{{ formatDecimal(this.totalCte) }}</p>
                  </div>
<!--                  <div class="d-flex align-items-center">-->
<!--                    <h6 class="m-0 me-2"> Total Carga CTe:</h6>-->
<!--                    <p class="m-0 me-4">{{ formatDecimal(this.totalCargaCte) }}</p>-->
<!--                  </div>-->
                  <div class="d-flex align-items-center">
                    <h6 class="m-0 me-2"> Total %:</h6>
                    <p class="m-0 me-4">{{ formatDecimal(this.totalPerc) }}</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <h6 class="m-0 me-2"> Dif. Total:</h6>
                    <p class="m-0 me-4">{{ formatDecimal(this.totaldif) }}</p>
                  </div>
                </div>
              </div>

            </b-card-header>

            <b-collapse id="accordion-7" visible accordion="my-accordion-7" role="tabpanel">
              <b-card-body>
                <div>
                  <DxToolbar>

                    <DxItem
                        location="before"
                        widget="dxButton">
                      <DxButton
                          icon="refresh"
                          hint="Redefinir formatação de tabela para padrão"
                          :on-click="refeFormTable"/>
                    </DxItem>

                    <DxItem
                        location="before"
                        widget="dxButton">
                      <DxButton
                          icon="decreaseindent"
                          hint="Cotar Frete"
                          :on-click="cotarFrete"/>
                    </DxItem>

                    <DxItem
                      location="before"
                      widget="dxButton"
                      v-if="docCobEditable"
                    >
                      <DxButton
                        icon="exportselected"
                        hint="Desvincular CTEs selecionados"
                        :on-click="unlinkCtes" 
                      />
                    </DxItem>

                    <DxItem
                        location="center"
                        locate-in-menu="never">
                      <div class="toolbar-label">Listagem de <b>{{ this.title }}</b></div>
                    </DxItem>
                  </DxToolbar>
                </div>

                <Loader v-if="updating" style="min-height: 300px;">
                </Loader>

                <div class="mt-2" v-if="!updating">
                  <DxDataGrid
                    ref="dataGridRefKey"
                    :data-source="docCobCtes"
                    :show-borders="true"
                    :focused-row-enabled="true"
                    keyExpr="id"
                    :column-auto-width="true"
                    :show-row-lines="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    @content-ready="carregouGrid"
                    @row-dbl-click="onRowDblClick"
                    @exporting="onExporting"
                    @cell-prepared="onCellPrepared"

                    >
<!--                    @selectionChanged="onSelectionChanged"-->

                    <DxRemoteOperations
                        :filtering="true"
                        :paging="true"
                        :sorting="true"
                        :summary="true"
                        :grouping="false"
                        :group-paging="false"
                    />


                    <DxColumnChooser :enabled="true"/>
                    <DxColumnFixing :enabled="true"/>
                    <DxFilterRow :visible="true" />
                    <DxHeaderFilter :visible="true" />

<!--                    <DxSelection mode="multiple" :allow-select-all="allowSelectAll" select-all-mode="allPages"/>-->
                    <DxSelection mode="multiple" select-all-mode="allPages"/>
<!--                    <DxSelection mode="multiple" select-all-mode="page"/>-->
                    <DxExport
                        :enabled="true"
                        :allow-export-selected-data="true"/>

                    <DxStateStoring
                        :enabled="true"
                        type="sessionStorage"
                        storage-key="strCteList"/>

                    <DxGroupPanel :visible="true"/>
                    <DxGrouping />

                    <DxColumn
                        sort-order="desc"
                        data-field="id"
                        caption="ID"
                        alignment="right"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="true"/>

                    <!--    Nota Fiscal       -->
                    <DxColumn
                        :width="380"
                        caption="Nota Fiscal"
                        alignment="center"
                        :allow-sorting="false"
                        :allowHeaderFiltering="false">

                      <DxColumn
                          :width="90"
                          data-field="nfdtemissao"
                          caption="Emissão NF"
                          alignment="right"
                          data-type="datetime"
                          format="dd/MM/yyyy"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false"/>

                      <DxColumn
                          :width="110"
                          data-field="nfnumnota"
                          caption="Nota Fiscal"
                          alignment="right"
                          data-type="text"
                          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                          :allowHeaderFiltering="false"/>

                      <DxColumn
                          :width="50"
                          data-field="nfserie"
                          caption="Série"
                          alignment="right"
                          data-type="text"
                          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                          :allowHeaderFiltering="false"/>

                      <DxColumn
                          :width="110"
                          data-field="nfvalor"
                          caption="Valor NF"
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false"/>

                    </DxColumn>

                    <!--    CT-e     -->
                    <DxColumn
                        :width="500"
                        caption="CT-e"
                        alignment="center"
                        :allow-sorting="false"
                        :allowHeaderFiltering="false">

                      <DxColumn
                          :width="80"
                          data-field="numero"
                          caption="Número CT-e"
                          alignment="right"
                          data-type="text"
                          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                          :allowHeaderFiltering="false"/>

                      <DxColumn
                          :width="110"
                          data-field="dtemissao"
                          caption="Emissão CT-e"
                          alignment="right"
                          data-type="datetime"
                          format="dd/MM/yyyy"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false"/>

                      <DxColumn
                          :width="110"
                          data-field="valor"
                          caption="Valor CT-e"
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false"/>

                      <DxColumn
                          data-field="movcte_dtcompr"
                          caption="Comprovante"
                          alignment="right"
                          data-type="datetime"
                          format="dd/MM/yyyy"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="true"/>

                      <DxColumn
                          :width="80"
                          data-field="ctexiste"
                          caption="CT-e"
                          alignment="right"
                          @cell-prepared = "onCellPrepared"
                          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                          :allowHeaderFiltering="false"/>
                    </DxColumn>

                    <!--    Conciliação       -->
                    <DxColumn
                        :width="110"
                        caption="Conciliação"
                        alignment="center"
                        :allow-sorting="false"
                        :allowHeaderFiltering="false">

                      <DxColumn
                          data-field="movcte_valor"
                          caption="Frete CTe"
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false"/> <!--Valor-->

                      <DxColumn
                          data-field="movcte_percentualcota"
                          caption="Frete %"
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false" />

                      <DxColumn
                          data-field="movcte_valoratucota"
                          caption="Frete Conc."
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false" /> <!--Valor Conc.-->

                      <DxColumn
                          data-field="movcte_difvalcota"
                          caption="Diferença"
                          alignment="right"
                          :format="formatDecimal"
                          @cell-prepared = "onCellPrepared"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false" />

                    </DxColumn>
                    <!--    Menor Frete       -->
                    <DxColumn
                        :width="110"
                        caption="Menor Frete"
                        alignment="center"
                        :allow-sorting="false"
                        :allowHeaderFiltering="false">

                      <DxColumn
                          data-field="movcte_valormincota"
                          caption="Frete Valor"
                          alignment="right"

                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false" />

                      <DxColumn
                          data-field="movcte_difvalmin"
                          caption="Diferença"
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false" />

                      <DxColumn
                          data-field="movcte_prazovalmin"
                          caption="Prazo"
                          alignment="right"
                          :format="formatInteger"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false" />
                    </DxColumn>

                    <!--    Menor Prazo       -->
                    <DxColumn
                        :width="110"
                        caption="Menor Prazo"
                        alignment="center"
                        :allow-sorting="false"
                        :allowHeaderFiltering="false">

                      <DxColumn
                          data-field="movcte_valorprazmin"
                          caption="Frete Valor"
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false" />
                      <DxColumn
                          data-field="movcte_difprazmin"
                          caption="Diferença"
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false" />

                      <DxColumn
                          data-field="movcte_prazomincota"
                          caption="Prazo"
                          alignment="right"
                          :format="formatInteger"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false" />
                    </DxColumn>

                    <DxPager
                        :visible="true"
                        :show-page-size-selector="true"
                        :allowed-page-sizes="[10, 30, 50]"
                        :show-navigation-buttons="true"
                        :show-info="true"/>
                  </DxDataGrid>
                </div>
              </b-card-body>
            </b-collapse>
          </div>
        </div>
      </form>
    </div>
  </Layout>

  <b-modal
      :title="'Gerar Financeiro do DocCob'"
      v-model="showModalFinan" hide-footer>
    <div class="row">

      <div class="col-6">
        <div class="mb-3">
          <label for="numero">Número Doc.</label>
          <input id="numero" v-model="financeiroData.numero" type="number" class="form-control" disabled
                 placeholder="Inserir valor"/>
        </div>
      </div>

      <div class="col-6">
        <div class="mb-3">
          <label for="valor">Valor</label>
          <input id="valor" v-model="financeiroData.valor" type="number" class="form-control" disabled
                 placeholder="Inserir valor"/>
        </div>
      </div>

      <div class="col-6">
        <div class="mb-3">
          <label for="emissao">Data de Emissão</label>
          <input id="emissao" v-model="financeiroData.emissao" type="date" class="form-control" disabled
                 placeholder="Data de Emissão" />
        </div>
      </div>

      <div class="col-6">
        <div class="mb-3">
          <label for="vencto">Data de Vencimento</label>
          <input id="vencto" v-model="financeiroData.vencimento" type="date" class="form-control" disabled
                 placeholder="Data de Emissão" />
        </div>
      </div>

<!--      <div class="col-6">
        <div class="mb-3">
          <label for="condpgto">Cond. de Pagamento</label>
          <multiselect id="condpgto" @search-change="pesqCondPgto" @select="escolheuCondPgto"
                       v-model="financeiroData.condpgto" placeholder="Pesq. condição de pagamento"
                       :options="dtListPesqCondPgto" :searchable="true" label="descricao" track-by="descricao" value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4">
                </span>
                <span class="mx-4">
                </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDate(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>-->

      <div class="col-6">
        <div class="mb-3">
          <label for="categoria">Categoria da Operação</label>
          <multiselect id="categoria"
                       @search-change="pesqCategoria"
                       @select="escolheuCategoria"
                       v-model="financeiroData.categoria"
                       placeholder="Pesquisar Categoria da Operação"
                       :options="dtlistPesqCategoria"
                       :searchable="true"
                       label="descricao"
                       :class="{'is-invalid':submitted && v$.financeiroData.categoria.$error,}"
                       class="multiselect-size"
                       track-by="id"
                       value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div>
                            <span class="">
                              {{ slotProps.option.id }}
                            </span>
                  <span class="ms-2" >
                              {{ slotProps.option.descricao }}
                            </span>
                </div>
              </div>
            </template>
          </multiselect>
<!--          <div v-if="submitted && v$.financeiroData.categoria.$error" class="invalid-feedback">
                      <span v-if="v$.financeiroData.categoria.required.$message">
                        {{ v$.financeiroData.categoria.required.$message }}
                      </span>
          </div>
          <span class="text-warning" v-if="!financeiroData.categoria && !submitted">Campo Obrigatório</span>-->
        </div>
      </div>

      <div class="col-6">
        <div class="mb-3">
          <label for="natureza">Natureza da Operação</label>
          <multiselect id="natureza"
                       @search-change="pesqNatureza"
                       @select="escolheuNatureza"
                       v-model="financeiroData.natureza"
                       placeholder="Pesquisar Natureza da operação"
                       :options="dtlistPesqNatureza"
                       :searchable="true"
                       label="descricao"
                       :class="{'is-invalid':submitted && v$.financeiroData.natureza.$error,}"
                       class="multiselect-size"
                       track-by="id"
                       value-prop="id"
                       :disabled="this.tipoFinTransp === 'R'" >
            <template #option="slotProps">
              <div class="row">
                <div>
                              <span class="">
                                {{ slotProps.option.id }}
                              </span>
                  <span class="ms-2" >
                                {{ slotProps.option.descricao }}
                              </span>
                </div>
              </div>
            </template>
          </multiselect>
<!--          <div v-if="submitted && v$.financeiroData.natureza.$error" class="invalid-feedback">
                        <span v-if="v$.financeiroData.natureza.required.$message">
                          {{ v$.financeiroData.natureza.required.$message }}
                        </span>
          </div>
          <span class="text-warning" v-if="!financeiroData.natureza && !submitted && (financeiroData.tabela && financeiroData.origem_id)">Campo Obrigatório</span>-->
        </div>
      </div>

      <div class="col-6">
        <div class="mb-3">
          <label for="banco">Instituição Bancária</label>
          <multiselect id="inputFinConta"
                       @search-change="pesqConta"
                       @select="escolheuConta"
                       v-model="financeiroData.banco_id"
                       placeholder="Selecione a Inst. Bancária"
                       :options="dtListPesqConta"
                       :searchable="true"
                       label="descricao"
                       :class="{'is-invalid':submitted && v$.financeiroData.banco_id.$error,}"
                       class="multiselect-size"
                       track-by="id"
                       value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div>
                            <span class="">
                              {{ slotProps.option.id }}
                            </span>
                  <span class="font-size-10 mx-1 me-4">
                               (banco: {{ slotProps.option.banco }})
                            </span>
                  <span class="" >
                              {{ slotProps.option.descricao }}
                            </span>

                </div>
              </div>
            </template>
          </multiselect>
<!--          <div v-if="submitted && v$.financeiroData.banco_id.$error" class="invalid-feedback">
                      <span v-if="v$.financeiroData.banco_id.required.$message">
                        {{ v$.financeiroData.banco_id.required.$message }}
                      </span>
          </div>
          <span class="text-warning" v-if="!financeiroData.banco_id && !submitted">Campo Obrigatório</span>-->
        </div>
      </div>

      <div class="col-6">
        <div class="mb-3">
          <label for="formapgto">Forma de Pgto</label>
          <multiselect id="formapgto"
                       @search-change="pesqFormaPgto"
                       @select="escolheuFormaPgto"
                       v-model="financeiroData.formapgto"
                       placeholder="Pesquisar forma de pagamento"
                       :options="dtListPesqFormaPgto"
                       :searchable="true"
                       label="descricao"

                       class="multiselect-size"
                       track-by="codigo"
                       value-prop="codigo"> <!--:class="{'is-invalid':submitted && v$.financeiroData.formapgto.$error,}"-->
            <template #option="slotProps">
              <div class="row">
                <div>
                          <span class="">
                            {{ slotProps.option.codigo }}
                          </span>
                  <span class="ms-2" >
                            {{ slotProps.option.descricao }}
                          </span>
                </div>
              </div>
            </template>
          </multiselect>
          <!--              <div v-if="submitted && v$.financeiroData.formapgto.$error" class="invalid-feedback">
                              <span v-if="v$.financeiroData.formapgto.required.$message">
                                {{ v$.financeiroData.formapgto.required.$message }}
                              </span>
                        </div>
                        <span class="text-warning" v-if="!financeiroData.formapgto && !submitted">Campo Obrigatório</span>-->
        </div>
      </div>

      <div class="col-6">
        <div class="mb-3">
          <label for="obs">Observações</label>
          <input id="obs" v-model="financeiroData.obs" type="text" class="form-control" placeholder="Observações" />
        </div>
      </div>

      <div class="col-6">
        <div class="col-8 mb-3 align-items-end align-content-start float-start">
          <label for="consutil">Considerar apenas dias úteis</label>
          <div id="consutil" style="margin-top: -15px">
            <b-form-checkbox switch size="lg" v-model="financeiroData.consutil" >
              {{ financeiroData.consutil === false ? 'Desativado' : 'Ativado' }}
            </b-form-checkbox>
          </div>
        </div>
      </div>

    </div>

    <div class="text-end mt-3">
      <b-button variant="danger" @click="showModalFinan = false">
        <i class="bx bx-block font-size-16 align-middle me-2"></i>
        Cancelar
      </b-button>
      <b-button variant="success" class="ms-1" @click="gerarFinanceiro">
        <i class="bx bx-money font-size-16 align-middle me-2"></i>
        Gerar Financeiro
      </b-button>
    </div>

  </b-modal>

  <b-modal
    :title="'Editar Cobrança - ' + docCobCobrEdit.numdoc"
    v-model="showModalCobr" hide-footer
    class="flex-column p-4"
  >
    <div class="col-6">
      <div class="mb-3">
        <label for="numdoc">Numero do documento</label>
        <input id="numdoc" v-model="docCobCobrEdit.numdoc" type="text" class="form-control" placeholder="Observações" />
      </div>
    </div>
    <div class="col- d-flex gap-4">
      <div class="mb-3">
        <label for="dtemissao">Emissão</label>
        <input type="date" id="dtemissao" v-model="docCobCobrEdit.dtemissao" class="form-control" />
      </div>
      <div class="mb-3">
        <label for="dtvencto">Vencimento</label>
        <input type="date" id="dtvencto" v-model="docCobCobrEdit.dtvencto" class="form-control" />
      </div>
    </div>
    <div class="col-6 d-flex gap-4">
      <div class="mb-3">
        <label for="nomeemis">Emissor Nome</label>
        <input id="nomeemis" v-model="docCobCobrEdit.nomeemis" type="text" class="form-control" placeholder="Observações" disabled/>
      </div>
      <div class="mb-3">
        <label for="cnpjemis">Emissor CNPJ</label>
        <input id="cnpjemis" v-model="docCobCobrEdit.cnpjemis" type="text" class="form-control" placeholder="Observações" disabled/>
      </div>
    </div>
    <div class="col-6 d-flex gap-4">
      <div class="mb-3">
        <label for="nometomador">Tomador Nome</label>
        <input id="nometomador" v-model="docCobCobrEdit.nometomador" type="text" class="form-control" placeholder="Observações" disabled/>
      </div>
      <div class="mb-3">
        <label for="cnpjtomador">Tomador CNPJ</label>
        <input id="cnpjtomador" v-model="docCobCobrEdit.cnpjtomador" type="text" class="form-control" placeholder="Observações" disabled/>
      </div>
    </div>

    <div class="mt-4">  
      <b-button 
        variant="outline-danger" 
        class="mx-2" 
        @click="showModalCobr = false; docCobCobrEdit = {}"
      >
        <i class="bx bx-block font-size-16 align-middle me-2"></i>
        Cancelar
      </b-button>

      <b-button
        variant="outline-success" 
        class="mx-2" 
        @click="saveDocCobCobr"
      >
        <i class="bx bx-money font-size-16 align-middle me-2"></i>
        Confirmar
      </b-button>
    </div>

  </b-modal>

</template>
